import { ESymbolRoles } from '@Core/Reels/SymbolRoles';
import { TSymbolSpineAsset } from '@GFTypes/SymbolAsset';

export interface ISymbolParameters {
    height: number;
    width: number;
    scale: number;
    baseWidth: number;
    baseHeight: number;
    baseScale: number;
}

export interface ISymbolConfig {
    id: number;
    asset: TSymbolSpineAsset;
    roles: ESymbolRoles[];
    symbolName: string;
    shortAnimationMode: EShortAnimationMode;
}

export enum EShortAnimationMode {
    ALWAYS = 'ALWAYS',
    ON_POSSIBLE_WIN = 'ON_POSSIBLE_WIN'
}
